import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from 'fronton-react';
import { useSelector } from 'react-redux';
import { Content } from 'features/content';
import { getRegionId, getWarningMessage } from 'features/page-model/ducks/get-model';
import { Infobar } from 'common/components/infobar';
import { analyticsUtils } from 'utils';
import { getIsAuthorized } from 'common/selectors/all-cookies';
import { getPathname } from 'common/selectors/location';
import { MainLayout } from 'pages/main-layout';
import { useEffectOnce } from '@navi-toolbox/hooks';
import { headingWrapper, warningMessageWrapper } from './style';

export const StoreList = memo(() => {
  const { t } = useTranslation();
  const warningMessage = useSelector(getWarningMessage);

  const regionId = useSelector(getRegionId);
  const isAuthorized = useSelector(getIsAuthorized);
  const url = useSelector(getPathname);

  useEffectOnce(() => {
    const onPageLoad = () => {
      analyticsUtils.sendEvent('GA:pageview', {
        pageType: 'ShopPage', // const тип страницы
        pagePath: url, // путь к странице
        userAuth: isAuthorized ? '1' : '0', // показатель авторизации
        platform: 'react', // const
        cityId: regionId, // id города
        businessModel: 'LM', // const
      });
    };

    if (document.readyState === 'complete') {
      onPageLoad();
    } else {
      window.addEventListener('load', onPageLoad);
    }
    return () => window.removeEventListener('load', onPageLoad);
  });

  const handleWMShow = useCallback(() => {
    analyticsUtils.sendEvent('GA:show', {
      elementType: 'block',
      elementBlock: 'shopPage',
      elementText: warningMessage, // номер телефона / магазин
      elementName: 'infobar', // название блока
    });
  }, [warningMessage]);

  return (
    <MainLayout>
      <div className={headingWrapper}>
        <Typography variant="h1" as="h1" data-qa="header" color="text-primary">
          {t('title', { companyBrand: t('legalName') })}
        </Typography>
        {warningMessage && (
          <Infobar
            message={warningMessage}
            className={warningMessageWrapper}
            hintPlacement="bottom-end"
            onShowBlock={handleWMShow}
          />
        )}
      </div>
      <Content />
    </MainLayout>
  );
});
